import type { StatusComponent } from '../api/statusApi';
import { STATUS_META, UNMONITORED_META } from '../statusMeta';
import { UptimeHistory } from './UptimeHistory';
import type { UptimeJson } from '../api/statusApi';
import './ComponentStatusList.css';

interface Props {
  components: StatusComponent[];
  uptime: UptimeJson | null;
}

export function ComponentStatusList({ components, uptime }: Props) {
  return (
    <section className="component-list card" aria-label="Component status">
      <h2>Components</h2>
      <ul className="component-list__items">
        {components.map((c) => {
          const unmonitored = c.monitored === false;
          const meta = unmonitored ? UNMONITORED_META : STATUS_META[c.status];
          return (
            <li key={c.id} className="component-row">
              <div className="component-row__top">
                <span className="component-row__name">{c.name}</span>
                <span
                  className="status-pill"
                  style={{ color: meta.color, background: meta.bg }}
                  title={unmonitored ? 'No live checks report on this component yet' : undefined}
                >
                  <span className="status-dot" style={{ background: meta.color }} aria-hidden="true" />
                  {meta.label}
                </span>
              </div>
              {uptime && <UptimeHistory days={uptime[c.id] ?? []} />}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
